import { ExecutionMonitor } from "@/features/treasury/liquidity";

export default function TreasuryLiquidityExecutionPage() {
  return <ExecutionMonitor />;
}